import { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import api, { errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

export default function DeleteDialog({ title, word, path, warning, onClose, onDone }) {
  const [v, setV] = useState("");
  const run = async () => {
    try {
      await api.delete(path, { params: { confirm: v } });
      toast.success("Permanently deleted");
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-red-700"><AlertTriangle className="w-5 h-5" /> {title}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">{warning} This cannot be undone.</p>
        <p className="text-sm">Type <b className="text-[#011E38]">{word}</b> to confirm.</p>
        <Input value={v} onChange={(e) => setV(e.target.value)} data-testid="delete-confirm-input" />
        <DialogFooter>
          <Button disabled={v.trim().toLowerCase() !== word.trim().toLowerCase()} onClick={run} className="bg-red-700 hover:bg-red-800" data-testid="delete-confirm-button">
            Delete permanently
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
